import { render } from "./ProductNav.vue?vue&type=template&id=3ec934bd&scoped=true"
import script from "./ProductNav.vue?vue&type=script&lang=js"
export * from "./ProductNav.vue?vue&type=script&lang=js"

import "./ProductNav.vue?vue&type=style&index=0&id=3ec934bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec934bd"]])

export default __exports__